/**
 * Meta Pixel (Facebook/Instagram Ads) — helper module.
 * Loads the pixel script lazily and exposes typed helpers for the
 * standard conversion events we care about on SelfBook Italia.
 *
 * Docs: https://developers.facebook.com/docs/meta-pixel/reference
 */

const PIXEL_ID = process.env.REACT_APP_META_PIXEL_ID;
let initialized = false;

export function initPixel() {
  if (initialized || !PIXEL_ID || typeof window === "undefined") return;
  // Standard Meta Pixel base snippet
  /* eslint-disable */
  (function (f, b, e, v, n, t, s) {
    if (f.fbq) return;
    n = f.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
    };
    if (!f._fbq) f._fbq = n;
    n.push = n; n.loaded = !0; n.version = "2.0"; n.queue = [];
    t = b.createElement(e); t.async = !0; t.src = v;
    s = b.getElementsByTagName(e)[0]; s.parentNode.insertBefore(t, s);
  })(window, document, "script", "https://connect.facebook.net/en_US/fbevents.js");
  /* eslint-enable */
  window.fbq("init", PIXEL_ID);
  window.fbq("track", "PageView");
  initialized = true;
}

function fire(event, params) {
  if (!PIXEL_ID) return;
  if (!initialized) initPixel();
  try { window.fbq("track", event, params || undefined); } catch { /* ignore */ }
}

export const trackPageView = () => fire("PageView");
export const trackLead = (data = {}) => fire("Lead", data);
export const trackCompleteRegistration = (data = {}) => fire("CompleteRegistration", data);
export const trackPurchase = (value, currency = "EUR") =>
  fire("Purchase", { value: Number(value) || 0, currency });
export const trackInitiateCheckout = (value, currency = "EUR") =>
  fire("InitiateCheckout", { value: Number(value) || 0, currency });
